import React from 'react'
import ActiveComponent from '../ActiveComponent'

import useViewModel from './ViewModel'
import formatNumberCommas from 'Utils/formatNumberCommas'

const MarketplaceTotalSaleChart: React.FC = () => {
	const { chartRef, currentDataType, setCurrentDataType } = useViewModel()

	return (
		<React.Fragment>
			<div className={`card border border-kumopack-grey-200  position-relative`}>
				<div className="card-body p-0">
					<div className="row g-5 align-items-xl-center">
						<div className="col-12 col-xl-6">
							<div
								ref={chartRef}
								id="marketplace_total_sale_chart"
								style={{ height: '350px' }}
								className="card-rounded-bottom"></div>
						</div>
						<div className="col-12 col-xl-6">
							<div className="w-fit-content position-absolute" style={{ top: '5%', right: '2%' }}>
								<div className="kumopack-button-group">
									<button
										className="btn btn-sm white-button text-kumopack-grey-700 fw-bold left"
										onClick={() => setCurrentDataType('today')}>
										{currentDataType === 'today' && <ActiveComponent />} Today
									</button>
									<button
										className="btn btn-sm white-button text-kumopack-grey-700 fw-bold middle"
										onClick={() => setCurrentDataType('thisweek')}>
										{currentDataType === 'thisweek' && <ActiveComponent />} This Week
									</button>
									<button
										className="btn btn-sm white-button text-kumopack-grey-700 fw-bold right"
										onClick={() => setCurrentDataType('thismonth')}>
										{currentDataType === 'thismonth' && <ActiveComponent />} This Month
									</button>
								</div>
							</div>

							<div className="row g-5">
								<div className="col-12 col-xl-4">
									<div className="fw-bold text-kumopack-grey-900">ยอดขาย</div>
									<div className="fs-2 fw-bold text-kumopack-grey-900">
										฿{formatNumberCommas(20000.89)}
									</div>
									<div className="text-kumopack-grey-600">เกี่ยวกับเมื่อวาน -20.00%</div>
								</div>
								<div className="col-12 col-xl-4">
									<div className="fw-bold text-kumopack-grey-900">จำนวนผู้เยี่ยมชม</div>
									<div className="fs-2 fw-bold text-kumopack-grey-900">
										{formatNumberCommas(100)}
									</div>
									<div className="text-kumopack-grey-600">เกี่ยวกับเมื่อวาน -20.00%</div>
								</div>
								<div className="col-12 col-xl-4">
									<div className="fw-bold text-kumopack-grey-900">จำนวนคำสั่งซื้อในตะกร้า</div>
									<div className="fs-2 fw-bold text-kumopack-grey-900">
										{formatNumberCommas(100)}
									</div>
									<div className="text-kumopack-grey-600">เกี่ยวกับเมื่อวาน -20.00%</div>
								</div>
								<div className="col-12 col-xl-4">
									<div className="fw-bold text-kumopack-grey-900">จำนวนคำสั่งซื้อ</div>
									<div className="fs-2 fw-bold text-kumopack-grey-900">
										{formatNumberCommas(100)}
									</div>
									<div className="text-kumopack-grey-600">เกี่ยวกับเมื่อวาน -20.00%</div>
								</div>
								<div className="col-12 col-xl-4">
									<div className="fw-bold text-kumopack-grey-900">จำนวนลูกค้าใหม่ที่สั่งสินค้า</div>
									<div className="fs-2 fw-bold text-kumopack-grey-900">
										{formatNumberCommas(100)}
									</div>
									<div className="text-kumopack-grey-600">เกี่ยวกับเมื่อวาน -20.00%</div>
								</div>
								<div className="col-12 col-xl-4">
									<div className="fw-bold text-kumopack-grey-900">จำนวนลูกค้าสั่งซ้ำ</div>
									<div className="fs-2 fw-bold text-kumopack-grey-900">
										{formatNumberCommas(100)}
									</div>
									<div className="text-kumopack-grey-600">เกี่ยวกับเมื่อวาน -20.00%</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default MarketplaceTotalSaleChart
